import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import fr from "@/locales/fr.json";
import es from "@/locales/es.json";
import pl from "@/locales/pl.json";
import it from "@/locales/it.json";
import pt from "@/locales/pt.json";
import nl from "@/locales/nl.json";
import sv from "@/locales/sv.json";
import da from "@/locales/da.json";
import no from "@/locales/no.json";
import ar from "@/locales/ar.json";
import bg from "@/locales/bg.json";
import hr from "@/locales/hr.json";
import cs from "@/locales/cs.json";
import id from "@/locales/id.json";
import hu from "@/locales/hu.json";
import tr from "@/locales/tr.json";
import de from "@/locales/de.json";
import zh from "@/locales/zh.json";
import uk from "@/locales/uk.json";
import vi from "@/locales/vi.json";

export const i18nResources = {
  en: { translation: en },
  ru: { translation: ru },
  fr: { translation: fr },
  es: { translation: es },
  pl: { translation: pl },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  sv: { translation: sv },
  da: { translation: da },
  no: { translation: no },
  ar: { translation: ar },
  bg: { translation: bg },
  hr: { translation: hr },
  cs: { translation: cs },
  id: { translation: id },
  hu: { translation: hu },
  tr: { translation: tr },
  de: { translation: de },
  zh: { translation: zh },
  uk: { translation: uk },
  vi: { translation: vi },
} as const;
